import { theme } from '../../theme';

function Table({ columns, data, loading, emptyMessage = 'No data found', onRowClick }) {
  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '3rem', color: theme.textMuted }}>
        <div
          style={{
            width: '36px',
            height: '36px',
            border: `3px solid ${theme.border}`,
            borderTop: `3px solid ${theme.primary}`,
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
            margin: '0 auto 1rem',
          }}
        />
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div style={{ overflowX: 'auto', width: '100%' }}>
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          fontSize: '0.875rem',
          minWidth: '600px',
        }}
      >
        <thead>
          <tr style={{ background: '#F8FAFC' }}>
            {columns.map((col, i) => (
              <th
                key={i}
                style={{
                  padding: '0.75rem 1rem',
                  textAlign: col.align || 'left',
                  fontWeight: 600,
                  color: theme.textMuted,
                  borderBottom: `2px solid ${theme.border}`,
                  whiteSpace: 'nowrap',
                  fontSize: '0.78rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  width: col.width,
                }}
              >
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data && data.length > 0 ? (
            data.map((row, rowIdx) => (
              <tr
                key={row.id || rowIdx}
                onClick={() => onRowClick && onRowClick(row)}
                style={{
                  borderBottom: `1px solid ${theme.border}`,
                  cursor: onRowClick ? 'pointer' : 'default',
                  transition: 'background 0.1s ease',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = '#F8FAFC')}
                onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
              >
                {columns.map((col, colIdx) => {
                  const colKey = col.key || col.accessor;
                  const cellValue = colKey !== undefined ? row[colKey] : row;
                  return (
                    <td
                      key={colIdx}
                      style={{
                        padding: '0.85rem 1rem',
                        color: theme.text,
                        verticalAlign: 'middle',
                        textAlign: col.align || 'left',
                      }}
                    >
                      {col.render ? col.render(cellValue, row) : (colKey !== undefined ? row[colKey] : null) ?? '—'}
                    </td>
                  );
                })}
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={columns.length}
                style={{
                  textAlign: 'center',
                  padding: '3rem',
                  color: theme.textMuted,
                }}
              >
                {emptyMessage}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
